import React from 'react';
import { ButtonRed, SignOutButton } from '../buttons';
import { AccountLink } from './AccountLink';
import { SimpleDialog } from '../SimpleDialog';
import { HeadsetHelp } from 'iconoir-react';
import { PatientDoc } from '../../types/Patient/PatientDoc';
import usePatientDoc from '../../hooks/usePatientDoc';
import { HamburgerMenu } from './HamburgerMenu';
import { useNetworkState } from '@uidotdev/usehooks';
import { Wifi, WifiWarning, WifiXmark } from 'iconoir-react';

export const Header = (props: { patientId: string }) => {
  const network = useNetworkState();
  const { patientId } = props;
  const patientDocQuery = usePatientDoc(patientId);
  const patientInfo = patientDocQuery.data as PatientDoc;
  const [open, setOpen] = React.useState(false);
  const [callLive, setCallLive] = React.useState(false);
  const [patientClosed, setPatientClosed] = React.useState(false);
  const [networkStatus, setNetworkStatus] = React.useState('online');
  const handleActionClick = () => {
    window.open('mailto:info@mideohealth.com');
    setOpen(false);
  };

  React.useEffect(() => {
    if (networkStatus === 'offline' && network.online === true) {
      setNetworkStatus('unstable');
      return;
    }
    if (networkStatus === 'online' && network.online === true) {
      setNetworkStatus('online');
      return;
    }
    if (network.online === false) {
      setNetworkStatus('offline');
      return;
    }
  }, [network, networkStatus]);

  React.useEffect(() => {
    if (patientInfo?.conciergeNavigator?.telehealthCallActive === true) {
      setPatientClosed(false);
      setCallLive(patientInfo?.conciergeNavigator?.telehealthCallActive);
    } else {
      setCallLive(false);
    }
  }, [patientInfo?.conciergeNavigator]);

  const handleTelehealthCall = () => {
    if (window && patientInfo.conciergeNavigator?.telehealthCallURL) {
      //@ts-expect-error - type checking for global Window not working in previous line?
      window.open(patientInfo.conciergeNavigator.telehealthCallURL, '_blank').focus();
    }
  };
  const handleCallDialogClose = (e: boolean) => {
    if (e === false) {
      setPatientClosed(true);
    }
  };

  return (
    <>
      <div className="h-12 w-full bg-stone-100 px-8">
        <div id="header-container" className="flex flex-row items-center justify-between">
          <div>{patientInfo && <HamburgerMenu navObj={patientInfo.navObj} />}</div>
          {callLive && (
            <div className="ml-16">
              <ButtonRed id="join-call-button" type="button" textContent="Join Call" onClick={handleTelehealthCall} />
            </div>
          )}
          {networkStatus === 'offline' && (
            <div className="ml-16 flex flex-row items-center">
              <WifiXmark height={'1.5em'} width={'1.5em'} color="#f56565" />
              <div className="font-bold text-red-500">Offline</div>
            </div>
          )}
          {networkStatus === 'unstable' && (
            <div className="ml-16 flex flex-row items-center">
              <WifiWarning height={'1.5em'} width={'1.5em'} color="#FFEB3B" />
              <div className="font-bold text-yellow-500">Unstable Connection</div>
            </div>
          )}
          {networkStatus === 'online' && (
            <div className="ml-16 flex flex-row items-center">
              <Wifi height={'1.5em'} width={'1.5em'} color="#48bb78" />
              <div className="">
                <p className="font-bold text-green-500">Online</p>
              </div>
            </div>
          )}
          <div className="flex flex-row items-center">
            <button onClick={() => setOpen(true)} className="">
              <HeadsetHelp />
            </button>
            <AccountLink />
            <div className="ml-4">
              <SignOutButton />
            </div>
          </div>
        </div>
      </div>
      <SimpleDialog
        open={open}
        setOpen={setOpen}
        title="Need Help?"
        content="Contact us by phone at 844-MIDEO-4U or click the button below to send us an email."
        actionButtonTitle="Send Email"
        actionButtonHandler={handleActionClick}
      />
      <SimpleDialog
        open={patientClosed === false && callLive}
        setOpen={handleCallDialogClose}
        title="Your Appointment is Live!"
        content="Click the button below to join the call in a new tab."
        actionButtonTitle="Join Call"
        actionButtonHandler={handleTelehealthCall}
      />
    </>
  );
};
